module.exports = __webpack_public_path__ + "img/30m3.ac7ff8a2.jpg";